/* -------------------------------------------------------------------------- */
/*          Enables user to open and close the categories or filters          */
/* -------------------------------------------------------------------------- */

document.addEventListener("DOMContentLoaded", function () {
  var acc = document.getElementsByClassName("hd-cats__title");
  var i;
  var mediaQuery = "(max-width: 992px)"; // Changed media query to 992px

  for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function (e) {
      e.preventDefault();
      this.classList.toggle("hd-cats__title--active");
      var panel = this.nextElementSibling;
      if (panel.style.maxHeight !== "0px") {
        panel.style.maxHeight = "0px";
      } else {
        panel.style.maxHeight = 5000 + "px";
      }
    });

    if (window.matchMedia(mediaQuery).matches === true) {
      if (acc[i].classList.contains("hd-cats__title--active")) {
        acc[i].nextElementSibling.style.maxHeight = "0px";
        acc[i].classList.remove("hd-cats__title--active");
      }
      var shopLayoutSide = document.querySelector(".shop-layout__side");
      shopLayoutSide.style.maxHeight = "0px";
    }
  }
});
